import React from 'react';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {  Row, Col } from 'react-bootstrap';


class Waitlists extends React.Component {
  constructor(props) {
    super(props);
  }

  parseItems = (items = [], courses = []) => {
    if (courses.length === 0) return [];
    return items.map(item => {
      const course = courses.filter(course => course.id === item.course)[0] || {};
      return {
        ...item,
        ...course,
        requestId: item.id,
        waitlist_position: `${item.waitlist_position} of ${course.waitlisted_students}`
      };
    });
  };

  handleBumpWaitlist = id => () => {
    // const { id: studentId } = this.props.student;
    this.props.courseActions.bumpWaitlist(id).then(() => {
      this.props.updateWaitlists()
    });
  };

  renderPosition(waitlistPosition, { status }) {
    if (status === 'pending') {
      return 'Pending'
    }

    return waitlistPosition
  }

  renderBump = (requestId, { status }) => {
    if (status === 'pending') {
      return null
    }
    console.log(requestId);
    return <button className="btn btn-raw" onClick={this.handleBumpWaitlist(requestId)}>BUMP</button>
  }

  render() {
    const { isLoading, items = [], courses = [], runSlug } = this.props;
    const parsedItems = this.parseItems(items, courses);
    const formatName = (courseSlug, course) => (
      <Link
        className="linkToClass"
        to={`/administer/${runSlug}/class/${course.id}`}
      >
        {courseSlug}
      </Link>
    );

    if (isLoading)
      return (
        <div>
          <div className="page-subtitle">Waitlists</div>
          <Spinner spinnerName="three-bounce" />
        </div>
      );
    if (items.length === 0)
      return (
        <div>
          <div className="page-subtitle">Waitlists</div>
          <p>No waitlists</p>
        </div>
      );
    return (
      <div className="administer-student-wailists">
        <div className="page-subtitle clearfix">
          <Row>
            <Col md={12}>
              <span>Waitlists</span>
            </Col>
          </Row>
        </div>
        <BootstrapTable
          data={parsedItems}
          bordered={false}
          hover={true}
          condensed={true}
        >
        <TableHeaderColumn
            dataField="slug"
            isKey={true}
            dataSort={true}
            dataFormat={formatName}
            width="10%"
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="longname" width="30%" dataSort={true}>
            Description
          </TableHeaderColumn>
          <TableHeaderColumn dataField="instructor" width="20%" dataSort={true}>
            Instructor
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="weight"
            dataAlign="center"
            dataSort={true}
            width="10%"
          >
            Credits
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="waitlist_position"
            dataFormat={this.renderPosition}
            dataAlign="center"
            dataSort={true}
            width="10%"
          >
            Position
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="requestId"
            dataAlign="center"
            dataSort={false}
            width="10%"
            dataFormat={this.renderBump}
          />
        </BootstrapTable>
      </div>
    );
  }
}

export default Waitlists;



// WEBPACK FOOTER //
// ./src/components/students/Waitlists.js